import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { LoadingService } from 'src/app/default/employees/services/loading.service';
import { IButtonTemplateModel } from './button-template-helpers/button-template-vm';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { ButtonRowComponent } from './button-template-helpers/button-row/button-row.component';

@Component({
  selector: 'app-button-template',
  templateUrl: './button-template.component.html',
  styleUrls: ['./button-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ButtonRowComponent, AsyncPipe],
})
export class ButtonTemplateComponent {
  public loadingService = inject(LoadingService);
  private activedRoute = inject(ActivatedRoute);

  @ContentChild('template') public template: TemplateRef<ContentChild>;
  @Input() public templateData$: Observable<IButtonTemplateModel>;
  public templateTitle$ = this.activedRoute.data.pipe(map((data) => data.title));
}
